module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-fill-98231a0d.svg";